<template>
  <div>
    <v-card-title>
      <v-spacer/>
      <v-btn
        dark
        color="red"
        round
        @click="newUser()"
      >
        <v-icon dark>add</v-icon>
        New User
      </v-btn>
    </v-card-title>
    <br />
    <v-layout
      row wrap
    >
      <v-flex
        sm12
        md3
        style="padding:0 5px 0 5px;"
      >
        <v-card>
          <v-toolbar
            dense
            flat
            color="primary"
            dark
          >
            Search &amp; Filtering
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="searchText"
              append-icon="search"
              label="Search Text"
              single-line
              hide-details
              @blur="search"
              v-on:keyup.enter="search"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="searchText='';search()"
            >
              Clear
            </v-btn>
            <v-btn
              color="primary"
              @click="search"
            >
              Search
            </v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        sm12
        md9
      >
        <v-card>
          <v-data-table
            :items="users"
            :headers="headers"
            :pagination.sync="pagination"
            :total-items="totalUsers"
            :rows-per-page-items="paginationStrings"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr>
                <td colspan="5">
                  <div style="text-align:center;padding:25px;">
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No Results</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr :class="{ 'disabled-user': !props.item.is_active }">
                <td>
                  <b>{{ props.item.last_name }}</b>
                </td>
                <td>
                  {{ props.item.first_name }}
                </td>
                <td>
                  {{ props.item.email }}
                </td>
                <td>
                  {{ props.item.username }}
                </td>
                <td class="justify-center layout px-0 align-center">
                  <v-spacer/>
                  <v-spacer/>
                  <v-icon
                    small
                    class="mr-2"
                    @click="passwordReset = true,edituser = props.item;"
                  >
                    vpn_key
                  </v-icon>
                  <v-spacer/>
                  <v-icon
                    small
                    class="mr-2"
                    @click="edit(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-spacer/>
                  <v-spacer/>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-fade-transition>
      <div
        v-if="editing"
        class="v-overlay v-overlay--active"
        style="z-index: 201;"
      ></div>
    </v-fade-transition>
    <v-dialog
      v-model="editing"
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      content-class="right-held"
      :hide-overlay="false"
    >
      <EditUser
        v-if="editing"
        @saveUser="save(arguments[0])"
        @stopEditing="editing = false;"
        @resetPassword="passwordReset=true"
        :user="edituser"
      />
    </v-dialog>
    <v-dialog
      v-model="passwordReset"
      width="400"
      transition="dialog-fade-transition"
    >
      <v-toolbar
        flat
        color="gray"
        dense
      >
        Password Reset
      </v-toolbar>
      <v-card
        v-show="changedPw"
        color="#FDFDFD"
      >
        <v-card-text style="text-align:center;">
          The user's new password is: <code>{{newPassword}}</code><br />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="passwordReset = false; newPassword = null; changedPw = false">OK</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
      <v-card
        v-show="!changedPw"
        color="#FDFDFD"
      >
        <v-card-text style="text-align:center;">
          <span>Set a password below, or click 'Generate Random Password' to set a random password.</span>
          <v-text-field
            v-model="newPassword"
            label="Set New Password"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            v-if="!newPassword"
            color="red"
            dark
            @click="resetPassword()"
          >
            Generate Random Password
          </v-btn>
          <v-btn
            v-if="newPassword"
            color="blue"
            dark
            @click="resetPassword()"
          >
            Set Password
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'
import EditingUser from '@/components/admin/EditingUser'

export default {
    name: "UserList",
    props: ["organization"],
    mixins: [
        pagination
    ],
    data() {
        return {
            users: [],
            pagination: {},
            editing: false,
            errorMessages: [],
            searchText: "",
            paginationStrings: [
                10,
                25,
                50
            ],
            headers: [
                { text: "Last Name", value: "last_name", },
                { text: "First Name", value: "first_name" },
                { text: "E-mail", value: "email", width: 275 },
                { text: "Username", value: "username" },
                {
                    text: "Actions",
                    align: "center",
                    sortable: false
                }
            ],
            loading: true,
            routing: false,
            edituser: {},
            saving: false,
            newPassword: "",
            changedPw: false,
            passwordReset: "",
            formTagSubs: [],
            contactTagSubs: [],
            tagStatus: "",
            addFormTag: false,
            addContactTag: false,
            filterContactTags: null,
            filterFormTags: null,
            tagFormSearch: null,
            tagContactSearch: null,
            tagSearchStorage: []
        };
    },
    computed: {
        totalUsers() {
            return this.pagination.totalItems;
        },
        tagFormResults() {
            return this.tagSearchStorage.filter(object => {
                var exists = false;
                this.formTagSubs.forEach(tagObject => {
                  if (tagObject.tag === object.tag) {
                    exists = true;
                  }
                });
                if (!exists) {
                    return object;
                }
            });
        },
        tagContactResults() {
            return this.tagSearchStorage.filter(object => {
                var exists = false;
                this.contactTagSubs.forEach(tagObject => {
                    if (tagObject.tag === object.tag) {
                        exists = true;
                    }
                });
                if (!exists) {
                    return object;
                }
            });
        }
    },
    watch: {
        tagContactSearch() {
            if (this.$data.tagContactSearch) {
                this.fetchContactTags();
            }
        },
        tagFormSearch() {
            if (this.$data.tagFormSearch) {
                this.fetchFormTags();
            }
        },
        filterFormTags() {
            this.addFormTag = false;
            if (this.$data.filterFormTags !== null) {
                this.formTagSubs.push(this.$data.filterFormTags)
                this.$data.tagFormSearch = null;
                this.tagSearchStorage = [];
                this.$data.filterFormTags = null
            }
        },
        filterContactTags() {
            this.addContactTag = false;
            if (this.$data.filterContactTags !== null) {
                this.contactTagSubs.push(this.$data.filterContactTags);
                this.$data.tagContactSearch = null;
                this.tagSearchStorage = [];
                this.$data.filterContactTags = null;
            }
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            api.users.superUser.list({
                search: this.searchText,
                ordering: (this.pagination.descending ? "-" : "") + this.pagination.sortBy,
                pageNum: this.pagination.page,
                count: this.pagination.rowsPerPage,
                filter: {
                    org: this.organization
                }
            })
                .then(data => {
                this.users = data.results
                this.pagination.page = data.page_number;
                this.pagination.totalItems = data.count;
                this.loading = false;
                this.componentCreated = true;
            });
        },
        edit(user) {
            this.edituser = JSON.parse(JSON.stringify(user));
            this.editing = true;
        },
        save(user) {
          this.errorMessages = [];
          user.org = this.organization;
          api.users.superUser.save(user, [400])
            .then(savedUser => {
              if (!this.edituser.id) {
                this.users.push(savedUser);
                this.edituser = savedUser;
                this.editing = false;
              }
              else {
                this.fetch();
                this.editing = false;
              }
            })
            .catch(error => {
              this.saving = false;
              if (error.response.status === 400) {
                this.errorMessages = JSON.parse(error.request.response);
              }
            });

        },
        resetPassword() {
            api.users.superUser.resetPassword(this.edituser.id, this.newPassword)
                .then(user => {
                this.loading = false;
                this.changedPw = true;
                this.newPassword = user.password;
            });
            this.loading = true;
        },
        fetchFormTags() {
            api.userform.userformTags.get(this.tagFormSearch)
                .then(tagResults => {
                this.tagSearchStorage = tagResults;
            });
        },
        fetchContactTags() {
            api.userform.contactTags.get(this.tagContactSearch)
                .then(tagResults => {
                this.tagSearchStorage = tagResults;
            });
        },
        updateFormTag(tag) {
            this.tagStatus = "saving";
            api.userform.adminUserformTags.updateSub(this.edituser.id, tag)
                .then(() => {
                this.tagStatus = "saved";
            })
                .catch(() => {
                this.tagStatus = "error";
            });
        },
        deleteFormSub(tag) {
            this.tagStatus = "saving";
            api.userform.adminUserformTags.deleteSub(this.edituser.id, tag)
                .then(() => {
                this.tagStatus = "saved";
                this.formTagSubs = this.formTagSubs.filter((oldTag) => {
                    if (oldTag !== tag) {
                        return oldTag;
                    }
                });
            })
                .catch(() => {
                this.tagStatus = "error";
            });
        },
        updateContactTag(tag) {
            this.tagStatus = "saving";
            api.userform.adminContactTags.updateSub(this.edituser.id, tag)
                .then(() => {
                this.tagStatus = "saved";
            })
                .catch(() => {
                this.tagStatus = "error";
            });
        },
        deleteContactSub(tag) {
            this.tagStatus = "saving";
            api.userform.adminContactTags.deleteSub(this.edituser.id, tag)
                .then(() => {
                this.tagStatus = "saved";
                this.contactTagSubs = this.contactTagSubs.filter((oldTag) => {
                    if (oldTag !== tag) {
                        return oldTag;
                    }
                });
            })
                .catch(() => {
                this.tagStatus = "error";
            });
        },
        newUser(){
          this.edituser = {};
          this.editing = true
        }
    },
    components: {
      'EditUser': EditingUser
    }
}
</script>

<style>

.right-held {
  right:0;
  left: unset !important;
  max-width: 1200px;
  bottom: 0;
  min-height: 100vh;
}

.disabled-user {
  background: #FFCDD2;
}

.search-bar {
  margin-top: 1em;
}

table {
  margin-top: 1em;
}

.edituser_dialog .v-dialog--fullscreen {
  top: 48px !important;
}

</style>
